import React from "react";
import { Col, FormFeedback, FormGroup, Input } from "reactstrap";

// formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function AddParentModule({ handleModuleChanges, moduleId }) {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      moduleName: "",
      moduleCode: "",
      // displayOrder: "",
    },

    validationSchema: Yup.object({
      moduleName: Yup.string().required("Please enter module name"),
      moduleCode: Yup.string().required("Please enter module code"),
      // displayOrder: Yup.string()
      //   .required("Please enter display order")
      //   .matches(/^[0-9]*$/, "Please enter only number"),
    }),
    onSubmit: (values) => {
      let modulePostData = {
        moduleName: values.moduleName,
        moduleCode: values.moduleCode,
        // displayOrder: values.displayOrder,
        moduleParentId: moduleId ? moduleId : null,
      };

      handleModuleChanges(modulePostData, "addModule");

      validation.resetForm();
    },
  });

  const handleSubmit = () => {
    validation.handleSubmit();
  };

  return (
    <>
      <td>
        <Col md="12">
          <FormGroup >
            <Input
              name="moduleName"
              placeholder=""
              type="text"
              className="form-control"
              id="validationCustom02"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.moduleName || ""}
              invalid={
                validation.touched.moduleName && validation.errors.moduleName
                  ? true
                  : false
              }
            />
            {validation.touched.moduleName && validation.errors.moduleName ? (
              <FormFeedback type="invalid">
                {validation.errors.moduleName}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
      </td>
      <td>
        <Col md="12">
          <FormGroup >
            <Input
              name="moduleCode"
              placeholder=""
              type="text"
              className="form-control"
              id="validationCustom02"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.moduleCode || ""}
              invalid={
                validation.touched.moduleCode && validation.errors.moduleCode
                  ? true
                  : false
              }
            />
            {validation.touched.moduleCode && validation.errors.moduleCode ? (
              <FormFeedback type="invalid">
                {validation.errors.moduleCode}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
      </td>
      {/* <td>
        <Col md="12">
          <FormGroup >
            <Input
              name="displayOrder"
              placeholder=""
              type="text"
              className="form-control"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.displayOrder || ""}
              invalid={
                validation.touched.displayOrder &&
                validation.errors.displayOrder
                  ? true
                  : false
              }
            />
            {validation.touched.displayOrder &&
            validation.errors.displayOrder ? (
              <FormFeedback type="invalid">
                {validation.errors.displayOrder}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
      </td> */}
      <td>
        <Col md="12">
          <FormGroup >
            <Input
              name="moduleType"
              placeholder=""
              type="text"
              className="form-control"
              value={moduleId ? "Submodule" : "Module"}
              readOnly
            />
          </FormGroup>
        </Col>
      </td>
      <td>
        <div className="col-8">
          <button
            className="btn w-0 btn-primary float-end"
            type="button"
            onClick={() => {
              handleSubmit(validation.values);
            }}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
      </td>
    </>
  );
}
